<template>
  <div class="video_wrap">
    <video
        ref="videoEl"
        controls
        v-if="$store.state.record_video_id"
        v-bind:src="$store.state.record_video_id"
    ></video>

    <div class="play_wrap" :class="{ hideen: playing }">
      <button class="play hover_op" @click="play_video"></button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      playing: false,
    };
  },

  methods: {
    play_video() {
      this.playing = true;
      this.$refs.videoEl.play();
    },
  },
  destroyed() {
    this.$store.commit(
        "setRecordVideoId",
        null
    );
  }
};
</script>

<style lang="scss" scoped>
.play_wrap {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.32);
  opacity: 1;
  transition: opacity 180ms;

  &.hideen {
    opacity: 0;
    transition: opacity 180ms;
    pointer-events: none;

    .play {
      opacity: 0;
      transition: opacity 180ms;
      pointer-events: none;
    }
  }
}

.play {
  width: 64px;
  height: 64px;
  z-index: 10;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 1;
  background: url("../../assets/img/play_video_btn.svg") no-repeat center /
    contain;
}

video {
  max-width: 100%;
}

.video_wrap {
  line-height: 0;
}
</style>